// extracted by mini-css-extract-plugin
export var emailBlockLink = "_os-0";